import { render } from "./SupporterReady.vue?vue&type=template&id=1fda70fa&scoped=true"
import script from "./SupporterReady.vue?vue&type=script&lang=js"
export * from "./SupporterReady.vue?vue&type=script&lang=js"

import "./SupporterReady.vue?vue&type=style&index=0&id=1fda70fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fda70fa"]])

export default __exports__